import { render } from "./echartsList.vue?vue&type=template&id=0c361c3b&scoped=true"
import script from "./echartsList.vue?vue&type=script&lang=js"
export * from "./echartsList.vue?vue&type=script&lang=js"

import "./echartsList.vue?vue&type=style&index=0&id=0c361c3b&scoped=true&lang=less"

import exportComponent from "D:\\work\\mvgx-carbon-space-admin-site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c361c3b"]])

export default __exports__